<template>
    <div class="relative mt-9 aspect-square w-full max-w-[37vh]">
        <img
            src="@/assets/images/games/killer/board.webp"
            :alt="$t('killer.logo_alt')"
            class="absolute h-full max-w-[unset] opacity-30"
        />

        <template v-for="(section, index) in sections" :key="section.angle">
            <svg
                width="100%"
                height="100%"
                viewBox="0 0 310 310"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                xml:space="preserve"
                xmlns:serif="http://www.serif.com/"
                :style="`fill-rule:evenodd;clip-rule:evenodd;transform:rotate(-${section.angle}deg)`"
                class="absolute"
            >
                <g id="Artboard1" transform="matrix(0.990122,0,0,0.99717,-350.625,-56.929)">
                    <rect
                        x="354.123"
                        y="57.091"
                        width="313.093"
                        height="310.88"
                        style="fill: none"
                    />
                    <g transform="matrix(0.919031,0,0,0.912535,334.489,-0.0711533)">
                        <g transform="matrix(1.09896,0,0,1.09896,21.3646,62.6406)">
                            <path
                                d="M146.237,210.536L155,211.207L163.763,210.536L168.243,238.82L155,239.839L141.757,238.82L146.237,210.536Z"
                                :style="`fill: ${section.color || '#FFFFFF'}; filter: brightness(90%) drop-shadow(0 0 4px ${section.color || '#FFFFFF'});`"
                                v-if="section.hits >= 3"
                            />
                        </g>
                        <g transform="matrix(1.09896,0,0,1.09896,21.3646,62.6406)">
                            <path
                                d="M155,211.207L146.237,210.536L150.075,186.305L159.925,186.305L163.763,210.536L155,211.207Z"
                                :style="`fill: ${section.color || '#FFFFFF'}; filter: brightness(90%) drop-shadow(0 0 4px ${section.color || '#FFFFFF'});`"
                                v-if="section.hits >= 2"
                            />
                        </g>
                        <g transform="matrix(1.09896,0,0,1.09896,21.3646,62.6406)">
                            <path
                                d="M153.533,164.47L156.467,164.47L159.925,186.305L150.075,186.305L153.533,164.47Z"
                                :style="`fill: ${section.color || '#FFFFFF'}; filter: brightness(90%) drop-shadow(0 0 4px ${section.color || '#FFFFFF'});`"
                                v-if="section.hits >= 1"
                            />
                        </g>
                    </g>
                </g>
                <g id="Artboard1" transform="matrix(0.990122,0,0,0.99717,-350.625,-56.929)">
                    <rect
                        x="354.123"
                        y="57.091"
                        width="313.093"
                        height="310.88"
                        style="fill: none"
                    />
                    <g transform="matrix(0.919031,0,0,0.912535,334.489,-0.0711533)">
                        <g transform="matrix(1,0,0,1,23.4406,-135.463)">
                            <defs>
                                <mask id="Mask">
                                    <g transform="matrix(1.09896,-0,-0,1.09896,-2.07599,198.104)">
                                        <image
                                            id="_Image1"
                                            width="310px"
                                            height="310px"
                                            xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAATYAAAE2CAAAAADO1+F1AAAACXBIWXMAAA7EAAAOxAGVKw4bAAABAElEQVR4nO3ZIQ7CQBRF0SnB1CDZEstCIxEsAAxrYRkIHAESBCQNBF+alHzRmYZz5Fcvd+SkBAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABApyr3gJb5rut6WA69o8c094CWetF1bQae0WeSe8A4yRYiW4hsIbKFyBYiW4hsIbKFyBYiW4hsIbKFyBYiW4hsIaVla46v3BN+UVq26+o0hm6lZXvs1+d37hH9SsuWbtvNPfeGfqX9XKVU1bOvt3xeciwBAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD4Yx9OJhLfTzZJ8gAAAABJRU5ErkJggg=="
                                        />
                                    </g>
                                </mask>
                            </defs>
                            <g mask="url(#Mask)">
                                <rect
                                    x="144.5"
                                    y="332.5"
                                    width="47.525"
                                    height="71.884"
                                    :style="
                                        'fill:none;stroke:' +
                                        (section.color || '#FFFFFF') +
                                        ';stroke-width:1px;filter:drop-shadow(0 0 2px ' +
                                        (section.color || '#FFFFFF') +
                                        ');'
                                    "
                                />
                                '
                            </g>
                        </g>

                        <g id="Outline" transform="matrix(1,0,0,1,-1.09896,2.94161)">
                            <g>
                                <g>
                                    <g transform="matrix(3.42583,0,0,3.42583,-341.628,-293.378)">
                                        <path
                                            d="M160.248,179.673C158.863,179.888 157.445,180 156,180C154.555,180 153.137,179.888 151.752,179.673"
                                            :style="
                                                'fill:none;stroke:' +
                                                (section.color || '#FFFFFF') +
                                                ';stroke-width:0.58px;stroke-miterlimit:10;filter:drop-shadow(0 0 2px ' +
                                                (section.color || '#FFFFFF') +
                                                ');'
                                            "
                                        />
                                    </g>
                                    <g
                                        transform="matrix(1.08543,-0.171915,0.176257,1.11284,-3.44969,87.0865)"
                                    >
                                        <path
                                            d="M156,161.906L156,235.328"
                                            :style="
                                                'fill:none;stroke:' +
                                                (section.color || '#FFFFFF') +
                                                ';stroke-width:1.78px;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:1.5;filter:drop-shadow(0 0 2px ' +
                                                (section.color || '#FFFFFF') +
                                                ');'
                                            "
                                        />
                                    </g>
                                    <g
                                        transform="matrix(1.08543,0.171915,-0.176262,1.11287,50.4014,33.4419)"
                                    >
                                        <path
                                            d="M156,161.908L156,235.329"
                                            :style="
                                                'fill:none;stroke:' +
                                                (section.color || '#FFFFFF') +
                                                ';stroke-width:1.78px;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:1.5;filter:drop-shadow(0 0 2px ' +
                                                (section.color || '#FFFFFF') +
                                                ');'
                                            "
                                        />
                                    </g>
                                </g>
                                <g transform="matrix(2.28037,0,0,2.28037,-162.935,-118.659)">
                                    <path
                                        d="M160.223,179.677C158.846,179.89 157.436,180 156,180C154.564,180 153.154,179.89 151.777,179.677"
                                        :style="
                                            'fill:none;stroke:' +
                                            (section.color || '#FFFFFF') +
                                            ';stroke-width:0.87px;stroke-miterlimit:10;filter:drop-shadow(0 0 2px ' +
                                            (section.color || '#FFFFFF') +
                                            ');'
                                        "
                                    />
                                </g>
                                <g transform="matrix(1.29899,0,0,1.29899,-9.84047,31.0306)">
                                    <path
                                        d="M160.167,179.685C158.808,179.893 157.416,180 156,180C154.584,180 153.192,179.893 151.833,179.685"
                                        :style="
                                            'fill:none;stroke:' +
                                            (section.color || '#FFFFFF') +
                                            ';stroke-width:1.52px;stroke-miterlimit:10;filter:drop-shadow(0 0 2px ' +
                                            (section.color || '#FFFFFF') +
                                            ');'
                                        "
                                    />
                                </g>
                            </g>
                            <g transform="matrix(0.375125,0,0,0.375125,134.283,173.047)">
                                <path
                                    d="M160.298,179.665C158.897,179.886 157.462,180 156,180C154.538,180 153.103,179.886 151.702,179.665"
                                    :style="
                                        'fill:none;stroke:' +
                                        (section.color || '#FFFFFF') +
                                        ';stroke-width:5.27px;stroke-miterlimit:10;filter:drop-shadow(0 0 3px ' +
                                        (section.color || '#FFFFFF') +
                                        ');'
                                    "
                                />
                            </g>
                        </g>
                    </g>
                </g>
            </svg>
            <div
                class="absolute -translate-x-1/2 translate-y-1/2 text-lg font-bold"
                :style="{
                    ...getPolarPosition(180 - section.angle, 0.7),
                    color: section.color || '#FFFFFF',
                }"
            >
                {{ index }}
            </div>
            <div
                v-if="section.avatar"
                class="clip-left-bottom-corner absolute h-8 w-8 -translate-x-1/2 translate-y-1/2 bg-white p-[1px] text-lg font-bold"
                :style="{
                    ...getPolarPosition(180 - section.angle, 0.9),
                    'background-color': section.color || '#FFFFFF',
                    'box-shadow': `0 0 10px ${section.color || '#FFFFFF'}`,
                }"
            >
                <div
                    class="clip-left-bottom-corner relative h-full w-full"
                    :style="{ backgroundColor: section.color || '#FFFFFF' }"
                >
                    <div
                        class="clip-left-bottom-corner absolute top-0 left-0 h-full w-full brightness-90"
                        :style="{ backgroundColor: section.color || '#FFFFFF' }"
                    ></div>
                    <img
                        v-avatar-fallback="section.avatar"
                        :alt="$t('general.avatar_alt')"
                        class="absolute top-0 left-0 z-10 h-full w-full object-cover"
                    />
                </div>
            </div>
            <div
                v-if="section.isKiller"
                class="absolute h-4 w-4 text-lg font-bold"
                :style="{
                    ...getPolarPosition(180 - section.angle, 0.5),
                    transform: `translate(-50%, 50%) rotate(${125 - section.angle}deg)`,
                }"
            >
                <svg
                    width="14"
                    height="15"
                    viewBox="0 0 14 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M6.51391 0.361233L1.08757 4.1608C0.803663 4.35959 0.747303 4.76934 0.961742 5.07559L2.32444 7.02173L0.750643 8.12372L2.11739 10.0756L3.69119 8.97365L4.48178 10.1027L2.90798 11.2047L4.27473 13.1566L5.84853 12.0546L7.21123 14.0008C7.42567 14.307 7.82999 14.3942 8.11389 14.1954L13.5402 10.3959C13.8241 10.1971 13.8805 9.78732 13.6661 9.48107L7.41576 0.554719C7.20132 0.248468 6.79701 0.161285 6.5131 0.360077L6.51391 0.361233ZM6.08337 6.37032L4.16474 3.63024L5.25537 2.86658L7.17399 5.60666L6.08337 6.37032ZM5.40239 7.53433L6.72025 7.69487L6.42037 8.98816L5.40239 7.53433ZM9.66572 11.4864L7.74709 8.74636L8.83772 7.9827L10.7563 10.7228L9.66572 11.4864Z"
                        fill="black"
                    />
                </svg>
            </div>
        </template>
    </div>
</template>

<script>
export default {
    name: 'Board',
    props: {
        sections: {
            type: Object,
            required: true,
        },
        selectedTarget: {
            type: Number,
            default: null,
        },
        isStartingStage: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        getPolarPosition(angle, percent) {
            // Convert angle to radians, 0 degrees is up
            const rad = ((angle - 90) * Math.PI) / 180
            // Center of container is 50%/50%
            const x = 50 + Math.cos(rad) * 50 * percent
            const y = 50 + Math.sin(rad) * 50 * percent
            return {
                left: `${x}%`,
                bottom: `${100 - y}%`,
            }
        },
    },
}
</script>
